/**
 * Saisie d'un payout : deux champs, deux montants stockés — `grossAmount`
 * débité du compte, `amount` reçu par le trader. Voir payoutAmounts.ts.
 *
 * Règles :
 * - net saisi → net tel quel, brut transmis s'il est saisi ;
 * - brut seul → brut == net.
 * Un brut inférieur au net est une saisie inversée : refusée.
 */
export interface PayoutFormValues {
  gross: string;
  net: string;
}

export const EMPTY_PAYOUT_VALUES: PayoutFormValues = { gross: "", net: "" };

export type PayoutFormResult =
  | { ok: true; amount: number; grossAmount: number | null }
  | { ok: false; reason: "empty" | "gross_below_net" };

const num = (raw: string): number => {
  const n = Number(raw.trim().replace(",", "."));
  return raw.trim() !== "" && Number.isFinite(n) ? n : NaN;
};

const round2 = (n: number) => Math.round(n * 100) / 100;

export function resolvePayoutForm(v: PayoutFormValues): PayoutFormResult {
  const gross = num(v.gross);
  const typedNet = num(v.net);

  let amount: number;
  if (typedNet > 0) amount = typedNet;
  else if (gross > 0) amount = gross;
  else return { ok: false, reason: "empty" };

  const grossAmount = gross > 0 ? gross : null;
  if (grossAmount !== null && grossAmount < amount) return { ok: false, reason: "gross_below_net" };
  return { ok: true, amount, grossAmount: grossAmount !== null && grossAmount > amount ? grossAmount : null };
}

/** Valeurs initiales du formulaire de modification d'un payout existant. */
export function payoutFormValuesFrom(p: { amount: number; grossAmount?: number | null }): PayoutFormValues {
  return {
    gross: p.grossAmount != null ? String(round2(p.grossAmount)) : "",
    net: String(round2(p.amount)),
  };
}
